import formsGetters from "./getters.js";
import formsMutations from "./mutations.js";
import formsActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      formsTimestamp: null,
      forms: [],
      submissions: [],
    };
  },
  getters: formsGetters,
  mutations: formsMutations,
  actions: formsActions,
};
